import React, { Component } from 'react';
import { Dropdown, Divider, Button } from 'semantic-ui-react';
import { toast } from 'react-toastify';
import _ from 'lodash';

import './ModalAd.css';

class ModalAd extends Component {
  state = {
    types: [],
    ads: [],
    form: {
      id: null,
      type: '',
      ad: '',
      adId: ''
    }
  };

  componentDidMount() {
    this.fillTypes();
    if (this.props.adToEdit) {
      this.initializeEdit(this.props.adToEdit);
    }
  }

  initializeEdit = async (adToEdit) => {
    const form = { ...this.state.form };

    form.id = adToEdit.id;
    form.type = adToEdit.type;
    form.adId = adToEdit.ad ? adToEdit.ad.id : null;
    form.ad = adToEdit.ad || null;
    const ads = this.fillAds(adToEdit.type);

    this.setState({ form, ads });
  };

  fillTypes = () => {
    const types = [];
    const { isDAA, objective } = this.props;

    if (isDAA) {
      types.push({ key: 0, value: 'DAA Carousel', text: 'DAA Carousel' });
      types.push({ key: 1, value: 'DAA Still', text: 'DAA Still' });
    } else if (objective === 'VIDEO_VIEWS') {
      types.push({ key: 0, value: 'Video', text: 'Video' });
      types.push({ key: 1, value: 'Cinemagraph', text: 'Cinemagraph' });
    } else {
      types.push({ key: 0, value: 'Canvas', text: 'Canvas' });
      types.push({ key: 1, value: 'Collection', text: 'Collection' });
      types.push({ key: 2, value: 'Carousel', text: 'Carousel' });
      types.push({ key: 3, value: 'Video', text: 'Video' });
      types.push({ key: 4, value: 'Cinemagraph', text: 'Cinemagraph' });
      types.push({ key: 5, value: 'Still', text: 'Still' });
    }

    this.setState({ types });
  };

  onTypeSelect = (event, { options, value }) => {
    const { form } = this.state;
    const type = _.find(options, (option) => {
      return option.value === value;
    });
    const { value: typeValue } = type || {};

    const ads = this.fillAds(typeValue);

    const newForm = { ...form };
    newForm.type = typeValue;

    this.setState((prevState) => ({ ...prevState, form: newForm, ads }));
  };

  fillAds = (type) => {
    const { adPrototypes } = this.props;

    const filteredPrototypes =
      adPrototypes instanceof Array
        ? adPrototypes.filter((ad) => {
            const { type: adType, asset_id: assetId } = ad;
            if (type.indexOf('DAA') !== -1) {
              const typeParts = type.split(' ');
              return adType === typeParts[0] && assetId === typeParts[1];
            }
            return adType === type;
          })
        : [];

    const ads = filteredPrototypes.map((prototype, index) => {
      const { name, id, qc_approved: qcApproved } = prototype;
      return {
        key: index,
        value: id,
        text: name,
        prototype,
        qcApproved
      };
    });

    return ads;
  };

  onAdSelect = (event, { options, value }) => {
    const { form } = this.state;
    const ad = _.find(options, (option) => {
      return option.value === value;
    });

    const { prototype, value: adId, qcApproved } = ad || {};

    if (!qcApproved) {
      toast.warn(
        `This ad has not been QC'ed. This package will not be able to launch until all ads have been qc'ed.`,
        {
          position: 'top-right',
          autoClose: 6000,
          hideProgressBar: true,
          closeOnClick: true,
          pauseOnHover: true,
          draggable: true
        }
      );
    }

    const newForm = { ...form };
    newForm.ad = prototype;
    newForm.adId = adId;

    this.setState((prevState) => ({ ...prevState, form: newForm }));
  };

  saveAd = () => {
    const { id, type, ad } = this.state.form;
    const name = ad ? ad.name : '';
    const { adset } = this.props;
    let adName = `${adset.adSetName}_${type}_${name}`;

    if (type === 'DAA Still') {
      adName = `${adset.adSetName}_Still_${name}`;
    } else if (type === 'DAA Carousel') {
      adName = `${adset.adSetName}_Carousel_${name}`;
    }

    const adData = {
      id,
      type,
      ad,
      name: adName
    };

    this.props.addAd(adData);
  };

  handleFormChange = (event, { name, value }) => {
    this.setState({ form: { ...this.state.form, [name]: value } });
  };

  render() {
    const { type, adId } = this.state.form;
    const { types, ads } = this.state;

    return (
      <div className="modal-adset-container">
        <Dropdown
          placeholder="Type"
          search
          id="type"
          selection
          value={type}
          options={types}
          onChange={this.onTypeSelect}
        />
        <Divider hidden />
        <Dropdown
          placeholder="Ad"
          search
          id="ad"
          selection
          value={adId}
          options={ads}
          onChange={this.onAdSelect}
        />
        <Divider hidden />
        <Button onClick={this.props.onCloseModalAd} size="small" color="grey">
          Cancel
        </Button>
        <Button onClick={this.saveAd} size="small" color="blue">
          Save
        </Button>
      </div>
    );
  }
}

export default ModalAd;



// WEBPACK FOOTER //
// ./src/screens/PackageBuilder/ModalAd.js